import { GoogleTagManagerUtil } from './features/app/utils/googleTagManager';

export const gtmUtil = new GoogleTagManagerUtil(window);
